import React, { useEffect, useRef, useState } from 'react';
import TauriSectionModalVisual from '../../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../../config.json';
import GaugeComponent from 'react-gauge-component';
import './OpalAdvancedGaugeDialVisual.css';

const OpalAdvancedGaugeDialVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    const handleDataPointSelection = (event) => {
        const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
        const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
        const selectedDesc = chartData[0][chartConfig.binding.data.title];
        const selectedVal = chartData[0][title];
        const selectedTitle = chartConfig.title;

        if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
            let selectedVisual = null;
            if (chartConfig.binding.context.point.onClick.visuals) {
                selectedVisual = chartConfig.binding.context.point.onClick.visuals;
            } else {
                selectedVisual = chartConfig.binding.context.point.onClick.visual;
            }

            setSelectedVisual(selectedVisual);
            setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

            const tauriElement = document.querySelector('.tauri-host-container');
            if (tauriElement) {
                if (event) {
                    let posX = event.clientX;
                    let posY = event.clientY;
                    if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                        posX = event.clientX - setting.modalMinWidth;
                    }
                    if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                        posY = event.clientY - setting.modalMinHeight;
                    }

                    setModalPosition({ x: posX, y: posY });
                }
            }
        }
    };

    let numerator = 0;
    let denominator = 0;

    if (chartData?.length > 0) {
        const item = chartData[0]; // or map it if you support multiple gauges
        numerator = item[chartConfig.binding.data.value] ?? 0;
        denominator = item[chartConfig.binding.data.total] ?? 1;
    }

    const value = (denominator !== 0) ? (numerator / denominator) * 100 : 0;

    const getPointerColor = (value) => {
        if (value < 30) return '#00C853';   // green
        if (value > 70) return '#D50000';   // red
        return '#FFD600';                   // yellow
    };

    const pointerColor = getPointerColor(value);

    return (
        <>
            <div className='chart-content' >
                <div className='advanced-gauge-dial-visual'
                    style={{
                        position: 'relative',
                        width: '80%',
                        height: '100%',
                        cursor: 'pointer',
                        display: 'flex',
                        justifySelf: 'center',
                        alignSelf: 'center'
                    }}
                    onClick={handleDataPointSelection}>
                    <GaugeComponent
                        type={chartOptions.type}
                        value={value}
                        minValue={chartOptions.minValue}
                        maxValue={chartOptions.maxValue}
                        arc={{
                            width: chartOptions.arc.width,
                            padding: chartOptions.arc.padding,
                            cornerRadius: chartOptions.arc.cornerRadius,
                            colorArray: [pointerColor, '#E4E4E4'],
                            subArcs: [
                                { length: value },
                                { length: 100 - value.toFixed(0) }
                            ]
                        }}
                        pointer={{
                            type: 'arrow',
                            color: pointerColor,
                            elastic: true
                        }}
                    />
                    <div className="gauge-overlay-text">
                        <div className="fraction">{numerator}/{denominator}</div>
                    </div>
                </div>
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </>
    );
};

export default OpalAdvancedGaugeDialVisual;
